// Runtime overrides driven by window.environment (set by /config.js):
//   1. webpack's publicPath — so a single image works at any sub-path (/temp3, /temp4, ...).
//   2. favicon — so the per-tenant icon can be picked from src/assets/img/<name>.svg at runtime.
//
// IMPORTANT: this file must be imported FIRST in src/index.tsx so the publicPath assignment
// runs before webpack tries to load any async chunk.

declare let __webpack_public_path__: string;

const env =
	typeof window !== "undefined" ? (window as { environment?: Record<string, string | undefined> }).environment : undefined;

// --- 1. publicPath -----------------------------------------------------------
const basePath = env?.REACT_APP_BASE_PATH ?? "/";
__webpack_public_path__ = basePath.endsWith("/") ? basePath : `${basePath}/`;

// --- 2. favicon swap ---------------------------------------------------------
// HtmlWebpackPlugin already injected <link rel="icon" href="/Kural.HASH.svg"> at build time.
// If the helm-provided FAVICON_NAME differs from the bundled default, swap to a lazy-loaded
// chunk that resolves to the matching SVG under src/assets/img/. `?favicon` matches a separate
// webpack rule (emits to assets/favicons/) so these SVGs don't collide with the same files
// imported statically elsewhere (which emit to assets/icon/).
const faviconName = env?.REACT_APP_FAVICON_NAME;
if (faviconName && faviconName !== "Kural") {
	import(
		/* webpackChunkName: "favicon" */
		/* webpackMode: "lazy-once" */
		`src/assets/img/${faviconName}.svg?favicon`
	)
		.then((mod: { default: string }) => {
			document.querySelectorAll("link[rel~='icon']").forEach((el) => el.remove());
			const link = document.createElement("link");
			link.rel = "icon";
			link.type = "image/svg+xml";
			link.href = mod.default;
			document.head.appendChild(link);
		})
		.catch(() => {
			// File doesn't exist for this tenant — keep the build-time default favicon.
		});
}
